import { useInstance } from '@meraki-internal/react-dependency-injection';
import { BulkMissionExport } from './BulkMissionExport';
import { AlertPresenter } from '../../app/AlertBinder';
import { DocumentIcon, ShareIcon } from '../../components/icons/Icons';
import { RevenueCatModel } from '../../paywall/revenue-cat/RevenueCatModel';
import { useSubscription } from '@meraki-internal/state';
import { PaywallDialogViewModel } from '../../paywall/PaywallDialogViewModel';
import { Button } from '../../components/button/Button';
import { useIsNative } from '../../support/hooks/useIsNative';

export const BulkExportMissionsButton: React.FC<{disabled?: boolean}> = ({ disabled }) => {
    const alert = useInstance(AlertPresenter);

    const isNative = useIsNative();

    const exporter = useInstance(BulkMissionExport);
    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    const paywallVM = useInstance(PaywallDialogViewModel);

    const onClick = async () => {
        const hasPurchased = await paywallVM.requirePurchase({ triggerSource: 'bulk-export' });
        if (hasPurchased){
            try {
                await exporter.exportToCSV();
            }
            catch (err){
                alert.showAndLogError(err);
            }
        }
    };

    return (
        <Button
            onClick={onClick}
            expand="block"
            fill="outline"
            dataType="export-missions-csv"
            newFeatureKey="export"
            disabled={disabled}
        >
            {isNative ? <ShareIcon /> : <DocumentIcon />}
            <span style={{ marginLeft: 10 }}>Export All</span>
        </Button>
    );
};
